
export const GET_TEMP_DATA = "GET_TEMP_DATA"
export const GET_TEMP_DATA_SUCCESS = "GET_TEMP_DATA_SUCCESS"
export const GET_TEMP_DATA_FAIL = "GET_TEMP_DATA_FAIL"


export const ADD_PUSH_ITEM = "ADD_PUSH_ITEM"
export const ADD_PUSH_ITEM_SUCCESS = "ADD_PUSH_ITEM_SUCCESS"
export const ADD_PUSH_ITEM_FAIL = "ADD_PUSH_ITEM_FAIL"

export const UPDATE_PUSH_ITEM = "UPDATE_PUSH_ITEM"
export const UPDATE_PUSH_ITEM_SUCCESS = "UPDATE_PUSH_ITEM_SUCCESS"
export const UPDATE_PUSH_ITEM_FAIL = "UPDATE_PUSH_ITEM_FAIL"

export const DELETE_REMOVE_ITEM = "DELETE_REMOVE_ITEM"
export const DELETE_REMOVE_ITEM_SUCCESS = "DELETE_REMOVE_ITEM_SUCCESS"
export const DELETE_REMOVE_ITEM_FAIL = "DELETE_REMOVE_ITEM_FAIL"

export const COMMON_FUNCTIONS_MANAGEMENT_API_ERROR = "COMMON_FUNCTIONS_MANAGEMENT_API_ERROR"